import * as R from 'ramda'
import { useParams } from 'react-router-dom'

import useAxios from 'hooks/useAxios'

/**
 * Per-survey rating choice order (`settings.setups.choiceOrder`).
 * Returns true when the survey is set to negative-first ("flipped").
 * Silently returns false outside `:surveyId` routes — the hook reads the
 * route param, so consumers must live under a survey route.
 */
export default function useSurveyChoiceOrder() {
  const { surveyId } = useParams()
  const { data } = useAxios({
    url: `account/survey/${surveyId}/`,
    skip: !surveyId,
  })

  return Boolean(R.path(['settings', 'setups', 'choiceOrder'], data))
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useSurveyChoiceOrder/index.js